import { useState } from "react";
import { useDispatch } from "react-redux";
import {signInService} from "../../../services/authService";
import {signIn} from "../../../store/actions/auth";
import form from "./schemas/form";
import initialValues from "./schemas/initialValues";
import validations from "./schemas/validations";

export const useSignIn = () => {

    const dispatch = useDispatch();

    const {formId, formField} = form;

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: "secondary",
        title: "",
        message: "",
        icon: "notifications",
    });

    const [show, setShow] = useState(false);

    const toggleSnackbar = () => setShow(!show);

    const submitForm = async (values, actions) => {
        try {

            const response = await signInService(values);

            actions.resetForm();

            setSnackbarConfig({
                message: "Sesión iniciada exitosamente",
                icon: "notifications",
                title: "Autenticación",
                color: "secondary",
            });

            setShow(true);

            dispatch(signIn(response.data.data.user.id, response.data.data.user.name));

        } catch (error) {

            setSnackbarConfig({
                message: error.response.data.message,
                icon: "cancel",
                title: "Autenticación",
                color: "warning",
            });
            setShow(true);
        }

        actions.setSubmitting(false);
    };

    return { snackbarConfig, formId, formField, validations, initialValues, show, toggleSnackbar, submitForm };
};
